/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * The delivery method widget (locker / in-store pickup selector) on the /cart page is injected at runtime by a
 * third-party app rather than the theme, so it takes a moment to appear after the cart loads. During that gap the
 * checkout button was clickable with no delivery method actually selected, sending customers into checkout without
 * shipping info and triggering a "delivery not available" error. We disable the checkout button until the widget
 * reports an active selection (or a fallback timeout elapses, so checkout never gets stuck disabled if the widget
 * fails to load).
 *
 * The mini-cart popover never loads this widget at all (confirmed: it's simply absent from that DOM, not just
 * slow), so it isn't handled here - its checkout button is hidden for shipping-required carts in
 * snippets/mini-cart.liquid instead, forcing those customers through /cart where the widget actually exists.
 */
(function() {
  var DELIVERY_METHOD_ACTIVE_SELECTOR = '[class*="mc-"].active';
  var FALLBACK_DELAY_MS = 6000;

  function gateCheckoutButtons() {
    var forms = document.querySelectorAll('.cart-recap[data-requires-shipping="true"]');

    forms.forEach(function(form) {
      if (form.hasAttribute('data-delivery-gate-attached')) {
        return;
      }

      var checkoutButton = form.querySelector('.cart-recap__checkout');
      if (!checkoutButton) {
        return;
      }

      form.setAttribute('data-delivery-gate-attached', 'true');

      if (document.querySelector(DELIVERY_METHOD_ACTIVE_SELECTOR)) {
        return;
      }

      checkoutButton.disabled = true;

      var stopWatching = function() {
        observer.disconnect();
        clearTimeout(fallbackTimer);
        checkoutButton.disabled = false;
      };

      var observer = new MutationObserver(function() {
        if (document.querySelector(DELIVERY_METHOD_ACTIVE_SELECTOR)) {
          stopWatching();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

      var fallbackTimer = setTimeout(stopWatching, FALLBACK_DELAY_MS);
    });
  }

  document.addEventListener('DOMContentLoaded', gateCheckoutButtons);
  document.addEventListener('cart:rerendered', gateCheckoutButtons);
})();

/**
 * Cart-total-aware free-shipping progress message on PDP (Box 2, sections/main-product.liquid).
 * Fetches /cart.js on connect and again on "product:added"/"cart:refresh" (see the
 * hooks documented at the top of this file) so the message stays in sync with the
 * shopper's actual cart total without a page reload - upgrading the static,
 * cart-unaware threshold line that shipped first.
 *
 * The remaining-amount and "unlocked" copy come from the theme's existing locale
 * keys (product.form.free_shipping_threshold_html, cart.general.free_shipping,
 * cart.general.free_shipping_remaining_html - the same ones the cart page's own
 * free-shipping bar already uses) passed through as data attributes with a
 * %%AMOUNT%% placeholder, rather than adding new translation keys: locales/lv.json
 * is at Shopify's per-file key-count cap.
 *
 * If the cart fetch fails, the element is simply left with whatever text it had -
 * the static threshold line rendered by Liquid on first paint, or the last
 * successful cart-aware state - rather than being cleared or broken.
 */
(function() {
  // Shopify's standard money_format placeholder syntax (amount, amount_no_decimals,
  // amount_with_comma_separator, etc.) - kept local since shopify_common.js (which
  // would otherwise provide Shopify.formatMoney) isn't loaded on the product page.
  function formatMoney(cents, format) {
    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decimals = parts[1] ? decimal + parts[1] : '';
      return dollars + decimals;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    var match = formatString.match(placeholderRegex);
    var value;

    switch (match && match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function updateProgress(el, cart) {
    var thresholdCents = parseInt(el.getAttribute('data-threshold-cents'), 10);
    var noteEl = el.querySelector('.product-form__shipping-note');
    var textEl = el.querySelector('.product-form__shipping-note-text');
    if (isNaN(thresholdCents) || !noteEl || !textEl) {
      return;
    }

    var remaining = thresholdCents - cart.total_price;

    if (remaining <= 0) {
      textEl.innerHTML = el.getAttribute('data-unlocked-text');
      return;
    }

    if (cart.item_count === 0) {
      // "vel" ("more") doesn't make sense with nothing in the cart yet - reuse
      // the same generic threshold copy already used for the pre-fetch static
      // fallback instead of a dedicated (and new) empty-cart locale key.
      textEl.innerHTML = el.getAttribute('data-empty-cart-text');
    } else {
      var formattedRemaining = formatMoney(remaining, el.getAttribute('data-money-format'));
      var template = el.getAttribute('data-remaining-template') || '';
      textEl.innerHTML = template.replace('%%AMOUNT%%', formattedRemaining);
    }
  }

  function refresh(el) {
    fetch(window.routes.cartUrl + '.js', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Cart fetch failed');
        }
        return response.json();
      })
      .then(function(cart) {
        updateProgress(el, cart);
      })
      .catch(function() {
        // Leave the element's current text alone (static SSR line, or last known-good state).
      });
  }

  function refreshAll() {
    document.querySelectorAll('product-free-shipping-progress').forEach(refresh);
  }

  window.customElements.define('product-free-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      refresh(this);
    }
  });

  document.addEventListener('product:added', refreshAll);
  document.addEventListener('cart:refresh', refreshAll);
  // Quantity decreases/removals in the mini-cart drawer call Cart._rerender()
  // directly (not via product:added) and dispatch "cart:rerendered" without
  // bubbles: true on a scoped element (.header__action-item--cart), so a
  // normal bubble-phase document listener never sees it - only the full
  // /cart page's rerender bubbles. A capture-phase listener catches both,
  // since capture doesn't depend on the event bubbling.
  document.addEventListener('cart:rerendered', refreshAll, true);
})();

